export default () => ({
    investors: [],
    investorsWithShares: [],
    investorsLoading: false,
    investorsInit: true,
    investorOptions: {},
    investorOptionsLoading: false,
    investorOptionsInit: true
});
